module.exports = __webpack_public_path__ + "5a00dc3d0e84d615e825bd2d22154c4f.MP3";